import React from 'react'

export const NotFound = () => {
    return(
     <h1>
         Page non trouvée
     </h1>
    )
}
